import { createFeatureSelector, createSelector } from "@ngrx/store";
import { arcHospiFeatureKey, ArcHospiState } from "./archospi.reducer";

export const getArcHospiFeature = createFeatureSelector<ArcHospiState>(arcHospiFeatureKey);

export const getArcHospi = createSelector(getArcHospiFeature, (state) => state.arcHospi);
